import { TokenUpgradeResponse, UserCheckResponse } from 'types/dto/login';
import ApiClient from 'services/apiClient';

export const requestOTP = async (phone: string) => {
  const response = await ApiClient.getInstance().post({
    url: '/signin/requestotp',
    data: { phone: phone },
  });

  return response.data;
};

export const loginWithOTP = async (
  phone: string,
  otp: string
): Promise<any> => {
  const response = await ApiClient.getInstance().post({
    url: '/signin/verify-otp',
    data: {
      phone: phone,
      otp: otp,
    },
  });
  return response.data;
};

export const loginWithPassword = async (
  phone: string,
  password: string
): Promise<any> => {
  const response = await ApiClient.getInstance().post({
    url: '/signin/login',
    data: {
      phone: phone,
      password: password,
    },
  });
  return response.data;
};

export const updatedTnc = async (phone: string,password: string) => {
  const response = await ApiClient.getInstance().post({
    url: '/common/updatedtnc',
    data: {
      phone: phone,
      password: password,
    },
  });

  return response.data;
};

export const checkUserStatus = async (
  country: string,
  mobile: string,
  email?: string
): Promise<UserCheckResponse> => {
  const response = await ApiClient.getInstance().get({
    url: '/signin/user/check',
    params: {
      country,
      mobile,
      email,
    },
  });

  return response.data;
};


// Attempt to upgrade temporary token to full access token
export const upgradeToken = async (
  tempToken: string
): Promise<TokenUpgradeResponse> => {
  const response = await ApiClient.getInstance().post({
    url: '/auth/upgrade-token',
    data: { tempToken },
  });

  return response.data;
};


export const requestResetPassword = async () => {
  const response = await ApiClient.getInstance().post({ url: '/auth/request-reset-password' });
  return response.data;
};

export const verifyPasswordResetToken = async (token: string) => {
  const response = await ApiClient.getInstance().post({
    url: '/register/verify-reset-token',
    data: { 'resetToken': token },
  });

  return response.data;
};

export const resetPassword = async (
  password: string,
  resetToken: string,
  accessToken: string
) => {
  const response = await ApiClient.getInstance().post({
    url: '/register/reset-password',
    data: {
      'password': password,
      'resetToken': resetToken,
      'accessToken': accessToken
    },
  });

  return response.data;
};

export const checksession = async (): Promise<TokenUpgradeResponse> => {
  const response = await ApiClient.getInstance().post({url: '/common/checksession' });

  return response.data;
};